import { ComponentPropsWithRef, forwardRef } from 'react';
import { Container, IContainerProps } from './styles';

interface IProps extends ComponentPropsWithRef<'div'>, IContainerProps {}

export const UICard = forwardRef<HTMLDivElement, IProps>(
  ({ children, borderVariant, containsForm, ...otherProps }, ref) => {
    if (containsForm && borderVariant) {
      throw new Error('Invalid props on UICard: pass EITHER containsForm or borderVariant but not both.');
    }

    return (
      <Container containsForm={containsForm} borderVariant={borderVariant} ref={ref} {...otherProps}>
        {children}
      </Container>
    );
  }
);

UICard.displayName = 'UICard';
